import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { compose, setDisplayName } from 'recompose';
import qs from 'query-string';
import { isEmpty, noop } from 'lodash';
import { Form } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Badge from '@material-ui/core/Badge';

import Serializer from 'helpers/form-serialize';
import ConfirmSignupIgnoreDialog from 'components/Home/ConfirmSignupIgnoreDialog';
import { signup } from 'redux/auth/actions';
import {
  getErrorSelector,
  selectState,
} from 'redux/selectors';

const styles = () => ({
  checkBox: {
    width: 'none',
    '&$checked': {
      color: 'gray',
    },
  },
  checked: {},
  icon: { fill: '#fff' },
  radioButton: {
    paddingRight: 10,
    width: 'auto',
  },
  radioLabel: {
    color: 'white',
    marginLeft: -10,
  },
  betaBadge: {
    backgroundColor: '#939393',
    right: - 3,
    top: -45,
    borderRadius: '11px',
    width: '30px',
    fontSize: '10px',
    height: '13px',
    color:'white'
  },
});

class SignUp extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
    classes: PropTypes.shape({}).isRequired,
    roles: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        name: PropTypes.string,
      }),
    ).isRequired,
    authError: PropTypes.shape({ detail: PropTypes.string }).isRequired,
    location: PropTypes.shape({ search: PropTypes.string }).isRequired,

    formatMessage: PropTypes.func.isRequired,
    signup: PropTypes.func.isRequired,
    handleEmail: PropTypes.func.isRequired,
    handlePassword: PropTypes.func.isRequired,
    userTypeTab: PropTypes.string,
    setUserTypeTab: PropTypes.func,
    isShopPage: PropTypes.bool,
  };

  static defaultProps = {
    userTypeTab: '',
    setUserTypeTab: noop,
    isShopPage: false,
  }

  constructor(props) {
    super(props);
    const presetValue = this.getPresetRoleValue(props.roles);
    this.state = {
      agreement: true,
      showSignupIgnore: false,
      value: presetValue,
      showPassword: false,
      email: '',
      userType: this.props.userTypeTab,
      password: '',
    };
    this.baseState = this.state;
  }

  componentWillReceiveProps(newProps) {
    if (!this.props.roles.equals(newProps.roles)) {
      const presetValue = this.getPresetRoleValue(newProps.roles);
      this.setState({ value: presetValue || this.state.value });
    }
    if (isEmpty(this.props.authError) && !isEmpty(newProps.authError) &&
      newProps.authError.detail &&
      (newProps.authError.detail.indexOf('auth.signup.ignoreBuyer') > -1 ||
      newProps.authError.detail.indexOf('auth.signup.ignoreSeller') > -1)) {
      this.setState({ showSignupIgnore: true });
    }
    if (newProps.email !== this.props.email){
      this.setState({email: newProps.email });
    }
  }

  resetForm = () => {
    this.setState(this.baseState)
  }

  onSubmit = (e) => {
    const { signup, history, handleEmail, handlePassword } = this.props;
    e.preventDefault();
    const signUpData = Serializer.serialize(e.target, { hash: true });
    if (!signUpData.email || !signUpData.password) {
      return;
    }
    signUpData.email = signUpData.email.trim();
    const { profileUrl, vendorEmail } = qs.parse(history.location.search.slice(1));
    if (profileUrl && vendorEmail) {
      signUpData.profileUrl = encodeURIComponent(profileUrl);
      signUpData.vendorEmail = encodeURIComponent(vendorEmail);
    }
    // signup(signUpData);
    signup({
      ...signUpData,
      forceSignup: 1,
      noDispatch: true,
      onSuccess: () => {
        const { isShopPage } = this.props;
        this.setState({ agreement: true }, () => this.signupForm.reset());
        this.resetForm();
        handleEmail('');
        handlePassword('');
      },
    });
  }

  getPresetRoleValue = (roles) => {
    const queryParams = qs.parse(this.props.location.search);
    if (queryParams && (queryParams.preset_role === 'customer' || queryParams.preset_role === 'vendor')
      && roles && roles.size > 0) {
      const role = roles.find(r =>
        r.get('name') === (queryParams.preset_role === 'customer' ? 'Buyer' : 'Seller'));
      return role ? `${role.get('id')}` : '';
    }
    return '';
  }

  confirmSignupIgnore = () => {
    const { signup } = this.props;
    const signUpData = Serializer.serialize(this.signupForm, { hash: true });
    signup({ ...signUpData, forceSignup: 1 });
    this.handleConfirmDlgClose();
  }

  handleCheck = (agreement) => {
    this.setState({ agreement });
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value });
  };

  handleConfirmDlgClose = () => this.setState({ showSignupIgnore: false })
  toggleVisibility = () => this.setState(prevState => ({ showPassword: !prevState.showPassword }))

  onChangeValue = (event) => {
    this.setState({email: event.target.value});
    this.props.handleEmail(event.target.value);
  }

  onChangePassword = (event) => {
    this.setState({password: event.target.value});
    this.props.handlePassword(event.target.value);
  }

  handleRadioChange = (event) => {
    const { setUserTypeTab } = this.props;
    this.setState({ userType: event.target.value });
    setUserTypeTab(event.target.value);
  }
  render() {
    const {
      authError,
      classes,
      formatMessage,
      isShopPage,
    } = this.props;
    const {
      agreement,
      showSignupIgnore,
      showPassword,
      userType,
      password,
    } = this.state;

    return (
      <Fragment>
        <Form
          className="signup-form mt-3"
          innerRef={(f) => { this.signupForm = f; }}
          onSubmit={this.onSubmit}
        >
          <div className="input-group-wrapper">
               
            <div className="input-group bottom-gap">
              <TextField
                className="input"
                id="email"
                name="email"
                value = {this.state.email}
                onChange={this.onChangeValue}  
                placeholder={formatMessage('Email')}
                required
                autoComplete="none"
                inputProps={{
                  autoCapitalize: "none",
                }}
                />
            </div>
            <div className="input-group bottom-gap">
              <TextField
                className="input"
                id="signup_password"
                name="password"
                value= {password}
                onChange={this.onChangePassword}
                placeholder={formatMessage('Password')}
                required
                type={showPassword ? 'text' : 'password'}
                autoComplete="none"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton style={{ outline: 'none' }} onClick={this.toggleVisibility}>
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
          <div className= "input-group bottom-container">
            <div className="term-policy">
              {formatMessage('I Agree To ')}
              <Link to="/terms">{formatMessage('Terms')}</Link> & <Link to="/privacy">{formatMessage('Privacy Policy')}</Link>
            </div>
            <Button
              style={{ textTransform: 'none', padding: 7, backgroundColor: isShopPage ? '#fbb143' : '#4695ec', color:'white' }}
              className="mt-1"
              disabled={!agreement || !userType}
              type="submit"
              variant="contained"
            >
              {formatMessage('Create Account')}
            </Button>
          </div>
         
        </Form>
        <ConfirmSignupIgnoreDialog
          description={authError.detail || ''}
          onClose={this.handleConfirmDlgClose}
          onConfirm={this.confirmSignupIgnore}
          open={showSignupIgnore}
          title={formatMessage('Warning')}
        />
      </Fragment>
    );
  }
}
/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'roles')(state, 'roles'),
  authError: getErrorSelector('auth', 'tokenInfo')(state).toJS(),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  signup: payload => dispatch(signup(payload)),
});

export default compose(
  setDisplayName('SignUp'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(SignUp);
